export enum AmountAggregatorPartType {
Aggregator,
Field,
}
